import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/tailwind-classes.css';
import './styles/shadcn-theme.css';
import App from './App';

// Silence console.log in production
if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.info = () => { };
  console.debug = () => { };
  // Keep console.warn and console.error for critical issue monitoring
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 